export default "__VITE_ASSET__BCu3C_CK__"